import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { AnalysisId } from 'src/app/analyses/interfaces/analysis-id.enum';

@Injectable({
  providedIn: 'root',
})
export class MeasurementAddHostService {
  public changeComponent$ = new Subject<AnalysisId | string>();
  // Selector of root page to redirect back to
  public rootPage = '';

  public changeComponent(
    componentSelector: AnalysisId | string,
    rootPage = ''
  ): void {
    this.changeComponent$.next(componentSelector);

    this.rootPage = rootPage;
  }

  public resetRootPage() {
    this.rootPage = '';
  }
}
